import React, { Component } from "react";
import { connect } from "react-redux";

import {
  selectCountry,
  deselectCountry,
  selectAllCountries,
  selectCategory,
  deselectCategory,
  selectAllCategories,
  selectOrderBy,
  selectAllOrderBy,
} from "./redux";

import {
  fetchResults,
} from "../Results/redux";

import DiscoverFilters from "./DiscoverFilters";

class DiscoverFiltersContainer extends Component {
  render() {
    const {
      countries,
      categories,
      onCountrySelect,
      onCountrySelectAll,
      onCountryDeselect,
      onCountryClose,
      onCategorySelect,
      onCategorySelectAll,
      onCategoryDeselect,
      onCategoryClose,
      selectedCategories,
      selectedCountries,
      selectedOrderBy,
      onOrderBySelect,
      onOrderBySelectAll,
    } = this.props;

    return (
      <DiscoverFilters
        countries={countries}
        categories={categories}
        onCountrySelect={onCountrySelect}
        onCountrySelectAll={onCountrySelectAll}
        onCategorySelect={onCategorySelect}
        onCategorySelectAll={onCategorySelectAll}
        onCountryDeselect={onCountryDeselect}
        onCountryClose={onCountryClose}
        onCategoryDeselect={onCategoryDeselect}
        onCategoryClose={onCategoryClose}
        selectedCategories={selectedCategories}
        selectedCountries={selectedCountries}
        selectedOrderBy={selectedOrderBy}
        onOrderBySelect={onOrderBySelect}
        onOrderBySelectAll={onOrderBySelectAll}
      />
    );
  }
}

export default connect(
  (state) => {
    const {
      browseHero: {
        selectedCategories,
        selectedCountries,
        selectedOrderBy,
      },
    } = state;
    return {
      selectedCategories,
      selectedCountries,
      selectedOrderBy,
    };
  },
  (dispatch) => ({
    onCountrySelect: (country) => {
      dispatch(selectCountry(country));
    },
    onCountrySelectAll: () => {
      dispatch(selectAllCountries());
    },
    onCategorySelect: (category) => {
      dispatch(selectCategory(category));
    },
    onCategorySelectAll: () => {
      dispatch(selectAllCategories());
    },
    onCountryDeselect: (country) => {
      dispatch(deselectCountry(country));
    },
    onCategoryDeselect: (category) => {
      dispatch(deselectCategory(category));
    },
    onCategoryClose: () => {
      dispatch(fetchResults());
    },
    onCountryClose: () => {
      dispatch(fetchResults());
    },
    onOrderBySelect: (orderBy) => {
      dispatch(selectOrderBy(orderBy));
      dispatch(fetchResults());
    },
    onOrderBySelectAll: () => {
      dispatch(selectAllOrderBy());
      dispatch(fetchResults());
    },
  }),
)(DiscoverFiltersContainer);
